export const navItems = [
  { label: 'HOME', href: '#home' },
  { label: 'ABOUT', href: '#about' },
  { label: 'ACTIVE SENIORS', href: '#active-adults' },
  { label: 'CLASSES', href: '#classes' },
  { label: 'TRAINERS', href: '#trainers' },
  { label: 'MEMBER APP', href: '#app' },
  { label: 'MEMBERSHIPS', href: '#membership-enrollment' },
  { label: 'KID CARE', href: '#kid-care' },
  { label: 'REVIEWS', href: '#reviews' },
  { label: 'CONTACT', href: '#contact' },
];

export const heroVideoId = 'jQfBpg1XFlU';

export const social = {
  facebook: 'https://www.facebook.com/FitnessProGymGalt/',
};

export const stats = [
  { value: 34, suffix: '+', label: 'Years Strong' },
  { value: 17000, suffix: ' SQ FT', label: 'Facility Size' },
  { value: 24, suffix: '/7', label: 'Open Hours' },
];

// Real classes from fitnessprogalt.com/classes (Summer 2026 schedule — updated June 2026)
export const classCategories = [
  { id: 'all', label: 'ALL CLASSES' },
  { id: 'strength', label: 'STRENGTH' },
  { id: 'cycling', label: 'CYCLING' },
  { id: 'dance', label: 'DANCE' },
  { id: 'mindbody', label: 'MIND & BODY' },
];

export const scheduleDays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

// Consolidated program families — each has ONE category-specific image + multiple sub-plans listed inside.
// Data here mirrors the printed "FITNESS PRO GYM 2026 Summer Schedule" exactly.
export const classPrograms = [
  {
    id: 'bootcamp',
    title: 'BOOT CAMP',
    tagline: 'Strength · HIIT · Total-Body',
    image: 'https://images.pexels.com/photos/31849599/pexels-photo-31849599.jpeg',
    location: 'BIG ROOM',
    blurb: 'Full body workouts that hit hard. From hardcore conditioning to age-appropriate strength — every session is led by a certified instructor with rotating routines so you never plateau.',
    plans: [
      {
        name: 'Boot Camp',
        level: 'ALL LEVELS',
        duration: '60 MIN',
        description: 'Full body workout packed into an hour. Instructors maximize each session and rotate routines weekly so consistent attendees keep changing it up for maximum benefit.',
        schedule: [
          { day: 'Mon', times: ['5:30 AM', '6:00 PM'] },
          { day: 'Tue', times: ['8:30 AM'] },
          { day: 'Wed', times: ['5:30 AM', '6:00 PM'] },
          { day: 'Thu', times: ['8:30 AM'] },
          { day: 'Fri', times: ['5:30 AM'] },
        ],
      },
      {
        name: 'Senior Fit',
        level: 'ALL LEVELS',
        duration: '45 MIN',
        description: 'Designed specifically for our senior population — building strength and stamina in a way that\u2019s appropriate for this phase of life.',
        schedule: [
          { day: 'Wed', times: ['10:30 AM'] },
          { day: 'Sat', times: ['10:30 AM'] },
        ],
      },
    ],
  },
  {
    id: 'spin',
    title: 'SPIN',
    tagline: 'Cycling · Cardio · Power',
    image: 'https://images.unsplash.com/photo-1615386703285-4fea008eef2d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwzfHxpbmRvb3IlMjBjeWNsaW5nfGVufDB8fHxibGFja3wxNzc4MTg1MjY2fDA&ixlib=rb-4.1.0&q=85',
    location: 'BIG ROOM',
    blurb: 'An intense cardio burn that mimics a real street ride — drills for hills, sprints, and raw power. Get on the bike, leave it all in the saddle.',
    plans: [
      {
        name: 'Spin',
        level: 'ALL LEVELS',
        duration: '45 MIN',
        description: 'Realistic cycling drills that simulate hills, sprints, and endurance — calorie-torching cardio with a coach calling the cadence.',
        schedule: [
          { day: 'Mon', times: ['8:30 AM'] },
          { day: 'Tue', times: ['5:30 PM'] },
          { day: 'Thu', times: ['5:30 PM'] },
        ],
      },
    ],
  },
  {
    id: 'zumba',
    title: 'ZUMBA',
    tagline: 'Latin Dance · Cardio · Pure Fun',
    image: 'https://images.unsplash.com/photo-1524594152303-9fd13543fe6e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwyfHxkYW5jZSUyMGZpdG5lc3N8ZW58MHx8fHwxNzc4MTg1MjY2fDA&ixlib=rb-4.1.0&q=85',
    location: 'BIG ROOM',
    blurb: 'Latin-inspired dance fitness that feels more like a party than a workout. Three formats so anyone can join the floor.',
    plans: [
      {
        name: 'Zumba',
        level: 'ALL LEVELS',
        duration: '60 MIN',
        description: 'Latin dance fitness class that burns major calories. You won\u2019t even know you\u2019re working out \u2014 it feels like a party.',
        schedule: [
          { day: 'Mon', times: ['7:15 PM'] },
          { day: 'Tue', times: ['6:30 PM'] },
          { day: 'Wed', times: ['7:15 PM'] },
          { day: 'Thu', times: ['6:30 PM'] },
          { day: 'Sat', times: ['8:45 AM'] },
        ],
      },
      {
        name: 'Zumba with Toning',
        level: 'ALL LEVELS',
        duration: '60 MIN',
        description: 'Classic Zumba dance flow with light toning sticks added in — keeps the cardio party going while layering in upper-body work.',
        schedule: [
          { day: 'Fri', times: ['9:00 AM'] },
        ],
      },
      {
        name: 'Zumba Gold',
        level: 'ALL LEVELS',
        duration: '45 MIN',
        description: 'All the fun of Zumba minus the high impact. Easier to follow \u2014 great for anyone who likes a chill pace.',
        schedule: [
          { day: 'Tue', times: ['10:30 AM'] },
          { day: 'Thu', times: ['10:30 AM'] },
        ],
      },
    ],
  },
  {
    id: 'yoga',
    title: 'YOGA',
    tagline: 'Flow · Breath · Mind & Body',
    image: 'https://images.unsplash.com/photo-1651077837628-52b3247550ae?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwzfHx5b2dhJTIwc3R1ZGlvfGVufDB8fHx8MTc3ODE4NTM4Mnww&ixlib=rb-4.1.0&q=85',
    location: 'YOGA ROOM',
    blurb: 'Four distinct yoga formats under one roof \u2014 from sunrise gentle flows to evening stillness work. Every level. Every mood.',
    plans: [
      {
        name: 'Core & Balance Yoga',
        level: 'ALL LEVELS',
        duration: '60 MIN',
        description: 'Extra focus on practices that strengthen your core and improve your balance.',
        schedule: [{ day: 'Tue', times: ['9:00 AM'] }],
      },
      {
        name: 'Restorative Yoga',
        level: 'ALL LEVELS',
        duration: '60 MIN',
        description: 'Gentle and nourishing. Focuses on small muscle groups and gradually increases flexibility.',
        schedule: [
          { day: 'Mon', times: ['10:30 AM'] },
          { day: 'Fri', times: ['10:30 AM'] },
        ],
      },
      {
        name: 'Yoga 4 Strength & Stillness',
        level: 'ALL LEVELS',
        duration: '60 MIN',
        description: 'Builds full-body strength and mental quiet through deliberate, held postures.',
        schedule: [
          { day: 'Tue', times: ['6:15 PM'] },
          { day: 'Thu', times: ['9:00 AM'] },
        ],
      },
      {
        name: 'Yoga for Flexibility',
        level: 'ALL LEVELS',
        duration: '60 MIN',
        description: 'A flow designed to safely deepen flexibility and unlock tight muscles.',
        schedule: [{ day: 'Thu', times: ['6:15 PM'] }],
      },
    ],
  },
  {
    id: 'pilates',
    title: 'PILATES',
    tagline: 'Lengthen · Strengthen · Sculpt',
    image: 'https://images.unsplash.com/photo-1614634053434-1729f6ac6bd6?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwxfHxwaWxhdGVzJTIwY2xhc3N8ZW58MHx8fGJsYWNrfDE3NzgxODUyNTN8MA&ixlib=rb-4.1.0&q=85',
    location: 'YOGA ROOM',
    blurb: 'Three distinct Pilates formats — from classical mat work to high-intensity fusion — for total-body conditioning and grace under pressure.',
    plans: [
      {
        name: 'Pilates',
        level: 'ALL LEVELS',
        duration: '60 MIN',
        description: 'Full body workout done with grace and slow, steady focus. Lengthens and strengthens muscles while increasing flexibility.',
        schedule: [
          { day: 'Mon', times: ['9:15 AM'] },
          { day: 'Fri', times: ['9:15 AM'] },
        ],
      },
      {
        name: 'Pilates Fusion',
        level: 'ALL LEVELS',
        duration: '60 MIN',
        description: 'Pilates lengthening + HIIT power. Modifiable to all levels for serious total-body conditioning.',
        schedule: [
          { day: 'Mon', times: ['6:30 PM'] },
          { day: 'Wed', times: ['6:30 PM'] },
          { day: 'Sat', times: ['9:00 AM'] },
        ],
      },
      {
        name: 'Pilates Fusion*** (45m)',
        level: 'ALL LEVELS',
        duration: '45 MIN',
        description: 'Express 45-minute Pilates Fusion variant — the same lengthen-plus-power formula condensed for a faster session.',
        schedule: [
          { day: 'Wed', times: ['8:30 AM'] },
        ],
      },
    ],
  },
];

// Real trainers from fitnessprogalt.com/trainers
export const trainers = [
  {
    id: 1,
    name: 'Amy Farris',
    first: 'AMY',
    last: 'FARRIS',
    role: 'Fitness Director · Yoga Therapist',
    summary: '14 years of holistic yoga therapy — restoring mobility, strength, and quality of life for seniors, athletes, and post-PT clients.',
    bio: 'Hello, my name is Amy Farris and I have been working with Fitness Pro for the past 14 years as an instructor and as the Fitness Director for the past 10 years. Staying physically healthy and well while helping others do the same has always been a passion of mine. Not only am I certified to teach and train in every class offered on our schedule, I have also been studying yoga therapy techniques under Dr. Ganesh (M.D. and Ayurvedic yoga therapist and practitioner) for the past 8 years. The Svastha Yoga Therapy Essentials program is a holistic way of approaching health and well being with clients; leading them through a journey that builds self awareness, strength, mobility, flexibility, and life skills to achieve a better quality of life for the whole person.',
    image: '/img/opxl6iun_HE2A5111copy.webp',
    specialty: 'YOGA THERAPY',
    phone: '(209) 712-3448',
    email: 'amy@fitnessprogalt.com',
    instagram: null,
    featured: true,
  },
  {
    id: 2,
    name: 'Bailey Davis',
    first: 'BAILEY',
    last: 'DAVIS',
    role: 'NASM CPT · Founder, B Brutal Athletics',
    summary: 'NASM-certified coach helping busy women build strength, energy, and confidence through workouts that fit real life.',
    bio: 'My name is Bailey Davis, and I am the founder of B Brutal Athletics, a NASM CPT and a mom of 2! As a busy mom, finding time for yourself can feel impossible, but prioritizing your health doesn\u2019t have to be overwhelming. I specialize in creating workout programs that fit seamlessly into your schedule, focused on building strength, improving energy, and boosting confidence. To "B Brutal" is to do hard things without disguising any unpleasantness — let\u2019s build a healthier, stronger version of YOU.',
    image: '/img/srxzx3ke_IMG_6776.webp',
    specialty: 'WOMEN\u2019S STRENGTH',
    phone: '(209) 327-8215',
    email: 'bbrutal.athletics@yahoo.com',
    instagram: null,
    featured: false,
  },
  {
    id: 3,
    name: 'Julio Camberos',
    first: 'JULIO',
    last: 'CAMBEROS',
    role: 'NASM-CPT/CNC · Chef Instructor',
    summary: 'Bilingual NASM-CPT/CNC and chef-instructor blending strength training, nutrition, and accountability for total transformation.',
    bio: '"It\u2019s not how much you can lift, it\u2019s how much you can control." As a personal trainer, nutrition coach and chef, I help clients committed to transforming their lives reach their fitness and nutrition goals. Specialty areas: men\u2019s health, strength training, hypertrophy, core, conditioning, nutrition, weight management. Bilingual English/Spanish.',
    image: '/img/kw6c0bgt_484479753_10071683222860328_67760423850269135_n.webp',
    specialty: 'STRENGTH · NUTRITION',
    phone: '(910) 261-4622',
    email: 'chefjulio@sbcglobal.net',
    instagram: null,
    featured: false,
  },
  {
    id: 4,
    name: 'Josie Davila',
    first: 'JOSIE',
    last: 'DAVILA',
    role: 'NASM CPT · Be Fit with Josie',
    summary: 'Military veteran, mom of 4, and NASM CPT — guiding women toward sustainable fitness through mindset, consistency, and small wins.',
    bio: 'Be Fit with Josie — Life as a mom of four (including a child with special needs) isn\u2019t easy. As a military veteran and divorced mom, I\u2019ve faced challenges from depression to addictions to high-stress lifestyle. Everything changed when I realized fitness isn\u2019t all-or-nothing — it\u2019s about mindset, consistency, and small achievable goals. As a NASM Certified Personal Trainer, I\u2019ll guide you to a balanced, sustainable lifestyle that fits your reality.',
    image: '/img/6sx0t834_Josie+Photo+Grayscale.webp',
    specialty: 'LIFESTYLE COACHING',
    phone: '(619) 208-9163',
    email: 'Josie.Davila.Befit@gmail.com',
    instagram: 'Josie.befit',
    featured: false,
  },
];

export const memberships = [
  {
    id: 1,
    name: '1-YEAR INDIVIDUAL',
    price: 49,
    period: 'per month',
    description: '1-Year Individual Membership with monthly payment option. On-site Kid Care add-on available so you can train uninterrupted.',
    highlight: false,
    badge: '1-YEAR INDIVIDUAL',
    cta: 'START MEMBERSHIP',
  },
  {
    id: 2,
    name: 'FAMILY PLAN',
    price: 49,
    period: 'starting per month',
    description: '1-Year Family Membership. First member added is $49. Price increases with each additional member. On-site Kid Care add-on keeps the whole family active.',
    highlight: true,
    badge: 'MOST POPULAR \u2022 FAMILY PLAN',
    valueBadge: 'BEST VALUE',
    cta: 'START FAMILY PLAN',
  },
  {
    id: 3,
    name: '1-YEAR PAID IN FULL',
    price: 490,
    period: 'one-time payment',
    description: '1-Year Paid in Full Family Membership. Total price is shown after all members are added. On-site Kid Care add-on available for active parents.',
    highlight: false,
    badge: '1-YEAR PAID IN FULL',
    cta: 'PAY IN FULL & SAVE',
  },
];

// Real positive reviews from reviews.birdeye.com/fitness-pro-galt-149565032713181
export const testimonials = [
  {
    id: 1,
    name: 'Tony Rivera',
    role: 'Google · Aug 2025',
    quote: 'I love our gym, it\u2019s a great place to workout and start the day.',
    rating: 5,
    source: 'google',
  },
  {
    id: 2,
    name: 'Diana Campos',
    role: 'Facebook · Member 5+ years',
    quote: 'I LOVE Fitness Pro! The staff makes you feel like you belong there. I enjoy the variety of group classes and have made awesome friendships along the way.',
    rating: 5,
    source: 'facebook',
  },
  {
    id: 3,
    name: 'Tiffanie Dawn Bednar',
    role: 'Facebook · Recommended',
    quote: 'I love the environment when I walk in. I never felt like I was being judged or watched. The staff are super nice and helpful \u2014 I leave feeling good. Best gym I\u2019ve been a member of and always look forward to going back.',
    rating: 5,
    source: 'facebook',
  },
  {
    id: 4,
    name: 'Jessica Renee Vizcarra',
    role: 'Facebook · Recommended',
    quote: 'I don\u2019t write reviews often, but FitnessPro is such a clean gym. I see employees always cleaning machines.',
    rating: 5,
    source: 'facebook',
  },
  {
    id: 5,
    name: 'Bobby Chao',
    role: 'Facebook · Recommended',
    quote: 'Great classes and equipment. Always friendly staff.',
    rating: 5,
    source: 'facebook',
  },
  {
    id: 6,
    name: 'Margaret Luginbill',
    role: 'Facebook · Recommended',
    quote: 'Great gym, good machines, great instructors, clean.',
    rating: 5,
    source: 'facebook',
  },
  {
    id: 7,
    name: 'Danielle Walker',
    role: 'Facebook · Recommended',
    quote: 'Love the atmosphere and the variety of classes.',
    rating: 5,
    source: 'facebook',
  },
  {
    id: 8,
    name: 'Jennifer Palmtag',
    role: 'Facebook · Recommended',
    quote: 'I am happy with facilities and the staff. I\u2019ve taken a few classes and have especially enjoyed the spin class with Kelleigh!',
    rating: 5,
    source: 'facebook',
  },
  {
    id: 9,
    name: 'Christina Friend-Edwards',
    role: 'Facebook',
    quote: 'Excellent place!! Everything.',
    rating: 5,
    source: 'facebook',
  },
  {
    id: 10,
    name: 'Graciela Rosales',
    role: 'Facebook · Recommended',
    quote: 'Nice place, very good classes. I love it.',
    rating: 5,
    source: 'facebook',
  },
];

export const reviewStats = {
  rating: 4.4,
  total: 220,
  fiveStar: 143,
};

export const team = [
  { name: 'Randy Morton', role: 'President', email: 'randy@fitnessprogalt.com' },
  { name: 'Amy Farris', role: 'Fitness Director', email: 'amy@fitnessprogalt.com' },
  { name: 'Aracely Garcia', role: 'Team Leader', email: 'aracely@fitnessprogalt.com' },
  { name: 'Gwen Stevenson', role: 'Marketing Director', email: 'gwen@fitnessprogalt.com' },
];

// Member App schedule preview (used in App Preview section)
export const todaySchedule = [
  { time: '5:30 AM', name: 'Boot Camp', coach: 'Bailey Davis', spots: 4, total: 20 },
  { time: '8:30 AM', name: 'Spin', coach: 'Amy Farris', spots: 7, total: 15 },
  { time: '9:15 AM', name: 'Pilates', coach: 'Amy Farris', spots: 9, total: 18 },
  { time: '6:00 PM', name: 'Boot Camp', coach: 'Julio Camberos', spots: 2, total: 20 },
  { time: '7:15 PM', name: 'Zumba', coach: 'Josie Davila', spots: 11, total: 25 },
];
